export class DashParceirosModel {

  codigoFornecedorSap: number;
  contrato: number;
  atividade: string;
  subAtividade: string;
  familia: string;
  grupo: string;
  subGrupo: string;
  proteina: string;
  centro: string;
  brF1: string;
  brF2: string;
  brF3: string;
  brF4: string;
  sigla: string;
  idSku: number;
  descricaoSku: string;
  descricaoParceiro: string;
  marca: string;
  shelfLife: number;
  precoMedio: number;
  planoPO: number;
  planoCiclo: number;
  planoCongelado: number;
  planoRevisado: number;
  producaoRealizada: number;
  producaoRecebida: number;
  dia: Date;
  semana: number;
  justificativa: string;
  tipoFrete: string;
  quantidadeQuebra?: number;
  inicioSemana?: Date;
  fimSemana?: Date;
  dataPrevistaChegadaFOB?: Date;

  constructor(
    codigoFornecedorSap: number,
    contrato: number,
    atividade: string,
    subAtividade: string,
    familia: string,
    grupo: string,
    subGrupo: string,
    proteina: string,
    centro: string,
    brF1: string,
    brF2: string,
    brF3: string,
    brF4: string,
    sigla: string,
    idSku: number,
    descricaoSku: string,
    descricaoParceiro: string,
    marca: string,
    shelfLife: number,
    precoMedio: number,
    planoPO: number,
    planoCiclo: number,
    planoCongelado: number,
    planoRevisado: number,
    producaoRealizada: number,
    producaoRecebida: number,
    dia: Date,
    semana: number,
    justificativa: string,
    tipoFrete: string,
    quantidadeQuebra?: number,
    inicioSemana?: Date,
    fimSemana?: Date,
    dataPrevistaChegadaFOB?: Date
  ) {
    this.codigoFornecedorSap = codigoFornecedorSap;
    this.contrato = contrato;
    this.atividade = atividade;
    this.subAtividade = subAtividade;
    this.familia = familia;
    this.grupo = grupo;
    this.subGrupo = subGrupo;
    this.proteina = proteina;
    this.centro = centro;
    this.brF1 = brF1;
    this.brF2 = brF2;
    this.brF3 = brF3;
    this.brF4 = brF4;
    this.sigla = sigla;
    this.idSku = idSku;
    this.descricaoSku = descricaoSku;
    this.descricaoParceiro = descricaoParceiro;
    this.marca = marca;
    this.shelfLife = shelfLife;
    this.precoMedio = precoMedio;
    this.planoPO = planoPO;
    this.planoCiclo = planoCiclo;
    this.planoCongelado = planoCongelado;
    this.planoRevisado = planoRevisado;
    this.producaoRealizada = producaoRealizada;
    this.producaoRecebida = producaoRecebida;
    this.dia = dia;
    this.semana = semana;
    this.justificativa = justificativa;
    this.tipoFrete = tipoFrete;
    this.quantidadeQuebra = quantidadeQuebra;
    this.inicioSemana = inicioSemana;
    this.fimSemana = fimSemana;
    this.dataPrevistaChegadaFOB = dataPrevistaChegadaFOB;
  }

  static toJson(model: DashParceirosModel): string {
    return JSON.stringify(model);
  }

  static fromJson(json: object[]): DashParceirosModel[] {
    return json.map((item: any) => {
      return new DashParceirosModel(
        item["codigoFornecedorSap"],
        item["contrato"],
        item["atividade"],
        item["subAtividade"],
        item["familia"],
        item["grupo"],
        item["subGrupo"],
        item["proteina"],
        item["centro"],
        item["brF1"],
        item["brF2"],
        item["brF3"],
        item["brF4"],
        item["sigla"],
        item["idSku"],
        item["descricaoSku"],
        item["descricaoParceiro"],
        item["marca"],
        item["shelflife"],
        item["precoMedio"],
        item["planoPO"],
        item["planoCiclo"],
        item["planoCongelado"],
        item["planoRevisado"],
        item["producaoRealizada"],
        item["producaoRecebida"],
        item["dia"],
        item["semana"],
        item["justificativa"],
        item["tipoFrete"],
        item["quantidadeQuebra"],
        item["inicioSemana"],
        item["fimSemana"],
        item["dataPrevistaChegadaFOB"]
      );
    });
  }

}

